import React from "react";
import "./Footer.scss"
import logo from "../../assets/logo.png"
import fb from "../../assets/fb.svg"
import insta from "../../assets/insta.svg"
import x from "../../assets/x.svg"
import yt from "../../assets/yt.svg"
import pin from "../../assets/pin.svg"
import email from "../../assets/email.svg"
import phone from "../../assets/phone.svg"
import MapLocationComponent from "./MapLocationComponent";
import { useSelector } from "react-redux";


const Footer = () => {
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);
    console.log(company, "companyDetails")
    return (
        <div className="HoppersCafeFooter">
            <div className="HoppersCafeFooter-inner">
                <div className="HoppersCafeFooter-inner-left">
                    <div className="HoppersCafeFooter-inner-left-logo">
                        <img
                            alt=""
                            src={logo} />
                    </div>

                    <div className="HoppersCafeFooter-inner-left-content">
                        Hoppers & Latte is where mornings begin with the warmth of a latte, and evenings glow with the spice of tradition.
                        We blend the vibrant flavours of Sri Lankan and Indian kitchens with the easy charm of a neighbourhood café — creating honest meals, rich brews, and a space that feels like home. </div>
                    <div className="HoppersCafeFooter-inner-left-cont">
                        {company?.SocialMedias
                            ?.facebook && company?.SocialMedias
                                ?.facebook !== "" && <div className="HoppersCafeFooter-inner-left-cont-ic"
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.facebook, '_blank')
                                    }} >
                                <img alt="" src={fb} />
                            </div>}
                        {company?.SocialMedias
                            ?.x && company?.SocialMedias
                                ?.x !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.x, '_blank')
                                    }}
                                    className="HoppersCafeFooter-inner-left-cont-ic">
                                <img alt="" src={x} />
                            </div>}
                        {company?.SocialMedias
                            ?.instagram && company?.SocialMedias
                                ?.instagram !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.instagram, '_blank')
                                    }}
                                    className="HoppersCafeFooter-inner-left-cont-ic">
                                <img alt="" src={insta} />
                            </div>}
                        {company?.SocialMedias
                            ?.youtube && company?.SocialMedias
                                ?.youtube !== "" && <div className="HoppersCafeFooter-inner-left-cont-ic"
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.youtube, '_blank')
                                    }}>
                                <img alt="" src={yt} />
                            </div>}
                    </div>



                </div>
                <div className="HoppersCafeFooter-inner-center">
                    <div className="HoppersCafeFooter-inner-center-header">
                        Opening Hours
                    </div>
                    <div className="HoppersCafeFooter-inner-center-cont">
                        <div className="HoppersCafeFooter-inner-center-cont-hdr">
                            <span
                                className="HoppersCafeFooter-inner-center-cont-hdr-spn" /> Cafe
                        </div>
                        <div className="HoppersCafeFooter-inner-center-cont-text">
                            6.00 am to 2.00 pm
                        </div>

                    </div>
                    <div className="HoppersCafeFooter-inner-center-cont">
                        <div className="HoppersCafeFooter-inner-center-cont-hdr">
                            <span
                                className="HoppersCafeFooter-inner-center-cont-hdr-spn" /> Restaurant
                        </div>
                        <div className="HoppersCafeFooter-inner-center-cont-text">
                            3.00 pm to 10.00 pm <br />Sri lankan & Indian  Cuisine
                        </div>
                    </div>
                    <div className="HoppersCafeFooter-inner-center-cont">
                        <div className="HoppersCafeFooter-inner-center-cont-hdr">
                            <span
                                className="HoppersCafeFooter-inner-center-cont-hdr-spn" /> Closed Hours
                        </div>
                        <div className="HoppersCafeFooter-inner-center-cont-text">
                            Everyday closed from 2.00 pm to 3.00 pm
                        </div>
                    </div>
                </div>
                <div className="HoppersCafeFooter-inner-center">
                    <div className="HoppersCafeFooter-inner-center-header">
                        Contact Us
                    </div>
                    <div className="HoppersCafeFooter-inner-center-cont-card">
                        <img
                            alt=""
                            src={pin}
                            className="HoppersCafeFooter-inner-center-cont-card-img" />
                        <div
                            className="HoppersCafeFooter-inner-center-cont-card-wrp">
                            <div
                                className="HoppersCafeFooter-inner-center-cont-card-wrp-hdr">
                                Location :
                            </div>
                            <div
                                className="HoppersCafeFooter-inner-center-cont-card-wrp-content">
                                25 Station Street, Kirkby-in-Ashfield, NG17 7AQ
                            </div>
                        </div>
                    </div>
                    <div className="HoppersCafeFooter-inner-center-cont-card">
                        <img
                            alt=""
                            src={email}
                            className="HoppersCafeFooter-inner-center-cont-card-img" />
                        {companyDetails.email && <div
                            className="HoppersCafeFooter-inner-center-cont-card-wrp">
                            <div
                                className="HoppersCafeFooter-inner-center-cont-card-wrp-hdr">
                                Email Address :
                            </div>
                            <div
                                className="HoppersCafeFooter-inner-center-cont-card-wrp-content">
                                {companyDetails.email}
                            </div>
                        </div>}
                    </div><div className="HoppersCafeFooter-inner-center-cont-card">
                        <img
                            alt=""
                            src={phone}
                            className="HoppersCafeFooter-inner-center-cont-card-img" />
                        {companyDetails.contactNumber && <div
                            className="HoppersCafeFooter-inner-center-cont-card-wrp">
                            <div
                                className="HoppersCafeFooter-inner-center-cont-card-wrp-hdr">
                                Phone Number :
                            </div>
                            <div
                                className="HoppersCafeFooter-inner-center-cont-card-wrp-content">
                                {companyDetails.contactNumber}
                            </div>
                        </div>}
                    </div>
                </div>
                <div className="HoppersCafeFooter-inner-center">
                    <div className="HoppersCafeFooter-inner-center-header">
                        Location
                    </div>
                    {companyDetails?.settings?.ShowAddressInMap && <MapLocationComponent lat={companyDetails?.address?.lat}
                        lng={companyDetails?.address?.lng}
                    />}
                </div>
            </div>
            <div className="HoppersCafeFooter-bottom">
                Copyright © 2025 Hoppers & Latte. All Rights Reserved.
            </div>
        </div >
    )
}
export default Footer